module.exports = __webpack_public_path__ + "media/src/assets/Images/DocumentsIcon-6d699a7f94354bd5c849fee1fefa63dd.svg";